// src/components/Sidebar.js
import { useAuth } from "../context/AuthContext";

const NAV = [
  { id: "dashboard",  icon: "⊞",  label: "Dashboard",       always: true },
  { id: "employees",  icon: "👥", label: "All Employees",    always: true },
  { id: "current",    icon: "✅", label: "Current Staff",    always: true },
  { id: "past",       icon: "🗂", label: "Past Employees",   always: true },
  { id: "attendance", icon: "📅", label: "Attendance",       always: true },
  { id: "users",      icon: "🔑", label: "Manage Users",     adminOnly: true },
];

export default function Sidebar({ active, setActive }) {
  const { profile, logout, isAdmin } = useAuth();

  const roleBadge = {
    admin: { label: "Admin", color: "var(--rust)" },
    hr: { label: "HR Manager", color: "var(--slate)" },
    principal: { label: "Principal", color: "#2d6a9f" },
    viewer: { label: "Viewer", color: "#666" },
  }[profile?.role] || { label: profile?.role || "Staff", color: "#666" };

  return (
    <aside style={{
      width: 230, background: "var(--slate)", display: "flex", flexDirection: "column",
      position: "fixed", top: 0, left: 0, bottom: 0, zIndex: 100, overflowY: "auto"
    }}>
      {/* Logo */}
      <div style={{ padding: "26px 20px 18px", borderBottom: "1px solid rgba(255,255,255,.07)" }}>
        <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: 3, color: "var(--rust-light)", textTransform: "uppercase", marginBottom: 5 }}>RKA Portal</div>
        <div style={{ fontSize: 16, fontWeight: 700, color: "#fff", fontFamily: "'Syne',sans-serif", lineHeight: 1.3 }}>Employee<br/>Management</div>
      </div>

      {/* Nav items */}
      <nav style={{ flex: 1, padding: "14px 10px", display: "flex", flexDirection: "column", gap: 2 }}>
        {NAV.filter(n => n.always || (n.adminOnly && isAdmin)).map(n => (
          <button key={n.id} onClick={() => setActive(n.id)} style={{
            display: "flex", alignItems: "center", gap: 10, padding: "10px 14px",
            borderRadius: 8, border: "none", cursor: "pointer", fontWeight: 500,
            fontSize: 13.5, transition: "all .18s",
            background: active === n.id ? "rgba(184,76,39,.22)" : "transparent",
            color: active === n.id ? "#fff" : "rgba(255,255,255,.58)",
            textAlign: "left", fontFamily: "'DM Sans',sans-serif"
          }}>
            <span style={{ fontSize: 15, flexShrink: 0 }}>{n.icon}</span>
            <span>{n.label}</span>
            {active === n.id && <div style={{ marginLeft: "auto", width: 4, height: 4, borderRadius: "50%", background: "var(--rust-light)" }} />}
          </button>
        ))}
      </nav>

      {/* User info + logout */}
      <div style={{ padding: "14px 16px", borderTop: "1px solid rgba(255,255,255,.07)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
          <div style={{ width: 36, height: 36, borderRadius: "50%", background: roleBadge.color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15, fontWeight: 700, color: "#fff", flexShrink: 0 }}>
            {(profile?.name || "U")[0].toUpperCase()}
          </div>
          <div style={{ overflow: "hidden" }}>
            <div style={{ fontSize: 13, color: "#fff", fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{profile?.name || "User"}</div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,.4)", marginTop: 1 }}>{roleBadge.label}</div>
          </div>
        </div>
        <button onClick={logout} style={{
          width: "100%", padding: "7px 12px", borderRadius: 7,
          border: "1px solid rgba(255,255,255,.12)", background: "transparent",
          color: "rgba(255,255,255,.55)", cursor: "pointer", fontSize: 12.5,
          textAlign: "left", fontFamily: "'DM Sans',sans-serif", transition: "all .2s"
        }}>⇠ Sign Out</button>
      </div>
    </aside>
  );
}
